import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  updateDoc,
  doc
} from "firebase/firestore";
import { db } from "../firebase/firebase";

import "./Verificacoes.css";

export default function VerificacoesPendentes() {
  const [lista, setLista] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  // ========================================================
  // 🔥 Buscar usuários com verificação pendente
  // ========================================================
  async function loadData() {
    const snap = await getDocs(collection(db, "users"));

    const pending = snap.docs
      .map((d) => ({ 
        id: d.id, 
        name: d.data().name || d.data().displayName || d.data().userName || "Usuário sem nome",
        profession: d.data().profession || "",
        verifyPhrase: d.data().verifyPhrase || "",
        verifySelfieUrl: d.data().verifySelfieUrl || "",
        verificationStatus: d.data().verificationStatus || "none"
      }))
      .filter((v) => v.verificationStatus === "pending");

    setLista(pending);
  }

  // ========================================================
  // ✓ Aprovar usuário
  // ========================================================
  async function aprovar(item) {
    if (!window.confirm(`Aprovar verificação de ${item.name}?`)) return;

    await updateDoc(doc(db, "users", item.id), {
      verificationStatus: "verified",
    });

    alert("Usuário aprovado!");
    loadData();
  }

  // ========================================================
  // ✗ Recusar usuário
  // ========================================================
  async function recusar(item) {
    if (!window.confirm(`Recusar verificação de ${item.name}?`)) return;

    await updateDoc(doc(db, "users", item.id), {
      verificationStatus: "rejected",
    });

    alert("Solicitação recusada.");
    loadData();
  }

  // Filtrar por termo de busca
  const filteredLista = lista.filter(v =>
    v.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (v.profession && v.profession.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  return (
    <div className="verif-container">
      <h2 className="title">Verificações Pendentes</h2>
      
      {/* Barra de busca */}
      <div className="controls-bar">
        <input 
          type="text" 
          className="search-input" 
          placeholder="Buscar por nome ou profissão..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div style={{ fontSize: '14px', color: '#666' }}>
          {filteredLista.length} de {lista.length} pendentes
        </div>
      </div>

      {filteredLista.length === 0 ? (
        <div className="no-data">
          <p>{searchTerm ? "Nenhuma solicitação pendente encontrada para sua busca." : "Nenhuma solicitação pendente encontrada."}</p>
        </div>
      ) : (
        <div className="ver-list">
          {filteredLista.map((v) => (
            <div key={v.id} className="ver-card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>{v.name}</h3>
                  <p style={{ margin: '5px 0', fontSize: '14px', color: '#666' }}>
                    <strong>Profissão:</strong> {v.profession || "—"}
                  </p>
                  {v.verifyPhrase && (
                    <p style={{ margin: '5px 0', fontSize: '14px', color: '#666' }}>
                      <strong>Frase enviada:</strong> "{v.verifyPhrase}"
                    </p>
                  )}
                </div>
                <span className="status pending">Pendente</span>
              </div>

              {v.verifySelfieUrl && (
                <div style={{ textAlign: 'center', margin: '15px 0' }}>
                  <img
                    src={v.verifySelfieUrl}
                    alt="Selfie"
                    className="ver-selfie"
                    style={{
                      width: '150px',
                      height: '150px',
                      borderRadius: '12px',
                      objectFit: 'cover',
                      border: '1px solid #eee',
                    }}
                  />
                </div>
              )}

              <div style={{ display: "flex", gap: "12px", marginTop: "18px" }}>
                <button
                  className="btn-approve"
                  onClick={() => aprovar(v)}
                >
                  Aprovar
                </button>

                <button
                  className="btn-reject"
                  onClick={() => recusar(v)}
                >
                  Recusar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}